import { createApp } from 'vue'
import TeamList from './TeamList'

const el = '.kb-component--team-list'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((TeamListDOM) => {
            const props = {
                source: TeamListDOM.dataset.source,
                stafetId: TeamListDOM.dataset.stafetId,
                take: TeamListDOM.dataset.take
                    ? parseInt(TeamListDOM.dataset.take)
                    : 18,
                guid: TeamListDOM.dataset.guid,
                filterShown: TeamListDOM.dataset.filterShown
                    ? TeamListDOM.dataset.filterShown === 'true'
                    : true
            }
            const component = createApp(TeamList, props).use(Store)
            component.mount(TeamListDOM)
        })
    }
}
